angular.module('theme').directive('mypageAnnouncementBar', function ($cookies, $document, CustomerService) {
	return {
		restrict: 'A',
		scope: {
			id: '@mypageAnnouncementBar',
			restrictions: '=',
			loyaltyLevel: '=',
			session: '<'
		},
		link: function ($scope, $element) {
			$scope.restricted = false;
			$scope.levelRestricted = false;
			var currentUrl = window.location.href;
			var closeBtn = angular.element($element[0].querySelector('.close'));

			CustomerService.get().then(function (customer) {
				var level = customer.loyaltyClub.level;

				var currentLevel;
				switch(level) {
				case 'Medlem':
					currentLevel = 0;
					break;
				case 'Brons':
					currentLevel = 1;
					break;
				case 'Silver':
					currentLevel = 2;
					break;
				case 'Guld':
					currentLevel = 3;
					break;
				case 'Platina':
					currentLevel = 4;
					break;	
				}
				
				$scope.levelRestricted = $scope.loyaltyLevel && $scope.loyaltyLevel.length > 0 && $scope.loyaltyLevel.indexOf(currentLevel) === -1;

				_.each($scope.restrictions.split(', '), function(value) {
					if (currentUrl.indexOf(value.replace('startsida/', '')) !== -1) {
						$scope.restricted = true;
					}
				});

				if (!$cookies.get('hide-bar-'+$scope.id) && !$scope.levelRestricted && (!$scope.restrictions || $scope.restricted)) {
					$element.addClass('d-block');
				}
			});

			closeBtn.bind('click', function(event) {
				event.preventDefault();

				// Save cookie only for session if set
				if ($scope.session) {
					$cookies.put('hide-bar-' + $scope.id, true, {
						path: '/'
					});
				} else {
					$cookies.put('hide-bar-' + $scope.id, true, {
						path: '/',
						expires: moment().add(1, 'month').toDate()
					});
				}

				$element.removeClass('d-block');
			});

		}
	};
});
